import React from 'react';
import Input from './Input';
import { Box, Button } from '@xceedsrl/jukebox';
import styled from 'styled-components';
import { CarteCulturaLogo } from '../logos/CarteCulturaLogo';
var TitleContainer = styled.span.withConfig({
  displayName: "DiciottoApp__TitleContainer",
  componentId: "sc-1bvws1y-0"
})(["font-family:Avenir;letter-spacing:normal;font-stretch:normal;font-style:normal;font-size:1em;font-weight:normal;color:#00112c;margin-left:8px;"]);
var Box18App = styled(Box).withConfig({
  displayName: "DiciottoApp__Box18App",
  componentId: "sc-1bvws1y-1"
})(["border:1px solid #e6e9eb;border-bottom-left-radius:12px;border-bottom-right-radius:12px;border-top-left-radius:", ";border-top-right-radius:", ";margin-top:", ";border-top-width:", ";background:#fff;cursor:pointer;position:relative;-webkit-transition:opacity 0.3s ease-out;transition:opacity 0.3s ease-out;width:100%;padding:0 16px;"], function (props) {
  return props.changeStyles ? '12px' : 0;
}, function (props) {
  return props.changeStyles ? '12px' : 0;
}, function (props) {
  return props.changeStyles ? '8px' : 0;
}, function (props) {
  return props.changeStyles ? '1px' : 0;
});
var HeaderContainer = styled.div.withConfig({
  displayName: "DiciottoApp__HeaderContainer",
  componentId: "sc-1bvws1y-2"
})(["display:flex;align-items:center;"]);
var Check = styled.span.withConfig({
  displayName: "DiciottoApp__Check",
  componentId: "sc-1bvws1y-3"
})(["background-color:#fff;border:1px solid #b9c4c9;border-top-color:rgb(185,196,201);border-right-color:rgb(185,196,201);border-bottom-color:rgb(185,196,201);border-left-color:rgb(185,196,201);border-top-color:rgb(185,196,201);border-right-color:rgb(185,196,201);border-bottom-color:rgb(185,196,201);border-left-color:rgb(185,196,201);border-radius:50%;height:16px;left:16px;-webkit-transition:border-color 0.2s ease-out,box-shadow 0.2s ease-out;transition:border-color 0.2s ease-out,box-shadow 0.2s ease-out;width:16px;margin-right:16px;"]);
var CheckActive = styled.span.withConfig({
  displayName: "DiciottoApp__CheckActive",
  componentId: "sc-1bvws1y-4"
})(["background-color:white;border:solid 5px #0075FF;-webkit-transition:all .3s ease-out;transition:all .3s ease-out;border-radius:50%;height:16px;left:16px;-webkit-transition:border-color .2s ease-out,box-shadow .2s ease-out;transition:border-color .2s ease-out,box-shadow .2s ease-out;width:16px;posdition:absolute;margin-right:16px;}&:hover{box-shadow:0 0 0 2px rgba(0,102,255,.4);}"]);
var style = {
  background: '#fff',
  border: '1px solid #b9c4c9',
  borderTopColor: 'rgb(185, 196, 201)',
  borderRightColor: 'rgb(185, 196, 201)',
  bordeBottomColor: 'rgb(185, 196, 201)',
  borderLeftColor: 'rgb(185, 196, 201)',
  borderRadius: '6px',
  caretColor: '#0075ff',
  color: '#00112c',
  display: 'block',
  fontFamily: 'inherit',
  fontSize: '1em',
  height: '40px',
  outline: 'none',
  padding: '5px 8px',
  position: 'relative',
  WebkitTransition: 'border 0.2s ease-out, box-shadow 0.2s ease-out',
  transition: 'border 0.2s ease-out, box-shadow 0.2s ease-out',
  width: '100%',
  marginBottom: '16px'
};
export var DiciottoApp = function DiciottoApp(_ref) {
  var value = _ref.value,
    handleClick = _ref.handleClick,
    onChange = _ref.onChange,
    isCarteCulturaSelected = _ref.isCarteCulturaSelected;
  return React.createElement(Box18App, {
    changeStyles: isCarteCulturaSelected
  }, React.createElement(HeaderContainer, {
    onClick: handleClick
  }, !isCarteCulturaSelected && React.createElement(Check, null), isCarteCulturaSelected && React.createElement(CheckActive, null), React.createElement(Button, {
    variant: "text",
    p: 0,
    py: 16,
    m: 0
  }, React.createElement(CarteCulturaLogo, null), React.createElement(TitleContainer, null, "Carta della cultura"))), isCarteCulturaSelected && React.createElement(Input, {
    value: value,
    key: "18app-voucher",
    name: "18app-voucher",
    dataType: "text",
    displayName: "Codice Voucher",
    required: true,
    pb: 16,
    handleChange: onChange,
    style: style,
    styleCheck: {
      top: '12px'
    },
    allowPaste: true
  }));
};
DiciottoApp.displayName = 'DiciottoApp';